export default __webpack_public_path__ + "5b08f3ef45b7339b47883e7f4222951f.svg";